import React, { useState, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

import {
  TableWaitingSwitchmanRequest,
  TableSwitchmanRequest,
  TableWaitingTeacherRequest,
  TableTeacherRequest,
} from '@features/inquiries/components/DirectInquiries/TablesDirect';

import { SubjectFilter } from '@features/inquiries/components/DirectInquiries/SubjectFilter';
import { useDirectInquiries } from '@features/inquiries/hooks/useInquiryQueries';
import BasicsContext from '@shared/context/BasicsContext';

const STORAGE_KEY = 'direct_filter_subjects';

const getInitialFilter = (user) => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null) {
    try {
      const parsed = JSON.parse(stored);
      // null means "show all"
      return parsed;
    } catch {
      // invalid JSON, fall through
    }
  }
  if (user && user.role.includes('teacher')) {
    return user.subjects.map((s) => s.name);
  }
  return null;
};

const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  rightRefresh: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    alignItem: 'flex-end',
    justifyContent: 'flex-end',
  },
}));

const TabDirect = ({ setSettings }) => {

  const classes = useStyles();

  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;

  const [filterSubjects, setFilterSubjectsState] = useState(() => getInitialFilter(user));

  const setFilterSubjects = useCallback((value) => {
    setFilterSubjectsState(value);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  }, []);

  // Utilisation du hook React Query
  const { data: directInquiries = {}, refetch } = useDirectInquiries();

  const {
    waitingSwitchman = [],
    withSwitchman = [],
    waitingTeacher = [],
    withTeacher = []
  } = directInquiries;

  const handleRedirectAlarm = () => {
    setSettings(true);
  };

  return (
    <div className={classes.column}>
      <SubjectFilter filterSubjects={filterSubjects} setFilterSubjects={setFilterSubjects} />

      {/* Requêtes en attente d'aiguillage */}
      <div className={classes.row}>
        <Tooltip title="Paramètre d'alarme">
          <IconButton aria-label="alarm" onClick={handleRedirectAlarm}>
            <NotificationsActiveIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Rafraichir">
          <IconButton aria-label="refresh" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </div>
      <TableWaitingSwitchmanRequest waitingSwitchmanInquiries={waitingSwitchman} filterSubjects={filterSubjects} />

      {/* Requêtes en cours d'aiguillage */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableSwitchmanRequest switchmanInquiries={withSwitchman} filterSubjects={filterSubjects} />

      {/* Requêtes en attente de traitement */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableWaitingTeacherRequest waitingTeacherInquiries={waitingTeacher} filterSubjects={filterSubjects} />

      {/* Requêtes en cours de traitement */}
      <Tooltip title="Rafraichir">
        <IconButton aria-label="refresh" onClick={() => refetch()} className={classes.rightRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <TableTeacherRequest teacherInquiries={withTeacher} filterSubjects={filterSubjects} />

    </div>
  );
};

export default TabDirect;
